import { FC, useEffect, useState } from "react";
import useNavigateTo from "hooks/useNavigateTo";
// i18next
import { useTranslation } from "react-i18next";
// Redux
import { useAppDispatch, useAppSelector } from "hooks/useStore";
// Actions
import { resetAnswersScore } from "store/player/playerSlice";
// Selectors
import { selectQuiz } from "store/quiz/quizSelectors";
import { selectExpertTotalScore, selectTotalScore } from "store/player/playerSelectors";
// Components
import AppBar from "components/AppBar";
import { Button } from "components/Buttons";
import PoweredBy from "components/PoweredBy";
// Icons
import { GiTrophyCup } from "react-icons/gi";
import { FaShieldAlt, FaHandshake } from "react-icons/fa";

const BeatTheExpertResult:FC = () => {
  const { t } = useTranslation();

  const navigateTo = useNavigateTo();

  const dispatch = useAppDispatch();

  const quiz = useAppSelector(selectQuiz);
  const totalScore = useAppSelector(selectTotalScore);
  const expertTotalScore = useAppSelector(selectExpertTotalScore);

  const [userScore] = useState(totalScore);

  const playerBeatExpert = totalScore >= expertTotalScore;
  const tied = totalScore === expertTotalScore;

  const iconClasses = 'text-7xl mx-auto mb-4 text-[#ff9100]';
  const icon = tied ? <FaHandshake className={iconClasses} /> : playerBeatExpert ? <GiTrophyCup className={iconClasses} /> : <FaShieldAlt className={iconClasses} />;

  const title = tied ? t('pages.beatTheExpertResult.tiedTitle') : playerBeatExpert ? t('pages.beatTheExpertResult.winTitle') : t('pages.beatTheExpertResult.loseTitle');
  const subtitle = tied ? t('pages.beatTheExpertResult.tiedSubtitle') : playerBeatExpert ? t('pages.beatTheExpertResult.winSubtitle') : t('pages.beatTheExpertResult.loseSubtitle');

  const onClick = () => navigateTo('register');

  useEffect(() => {
    if (!playerBeatExpert) {
      dispatch(resetAnswersScore());
    }
    // eslint-disable-next-line
  }, [playerBeatExpert]);

  return (
    <div
      className="p-4 flex flex-col w-full h-full bg-gray-200 overflow-y-auto"
      style={{ background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '' }}
    >
      <AppBar />
      <div className="flex-1 text-primary pt-8">
        {icon}
        <h1 className="text-center text-3xl font-bold uppercase text-[#ff9100] mb-2">{title}</h1>
        <p className="text-center text-md mb-8">{subtitle}</p>

        <div className="flex justify-around gap-4 mb-8">
          <div>
            <p className="text-center text-md uppercase text-[#ff9100]">{t('pages.beatTheExpertResult.yourScore')}</p>
            <p className={`text-center text-2xl font-bold uppercase ${playerBeatExpert ? '' : 'opacity-75'}`}>{`${userScore} ${t('labels.points')}`}</p>
          </div>
          <div>
            <p className="text-center text-md uppercase text-[#ff9100]">{t('pages.beatTheExpertResult.expertScore')}</p>
            <p className={`text-center text-2xl font-bold uppercase ${playerBeatExpert ? 'opacity-75' : ''}`}>{`${expertTotalScore} ${t('labels.points')}`}</p>
          </div>
        </div>

        <Button
          className="w-full flex items-center justify-center gap-3 uppercase primary-button mb-4"
          onClick={onClick}
        >
          {t('buttons.next')}
        </Button>
      </div>
      <PoweredBy />
    </div>
  )
}

export default BeatTheExpertResult;
